import { create } from "zustand";
import { persist } from "zustand/middleware";
import type UserRole from "../interfaces/UserRole";

interface User {
  id?: string;
  name: string;
  lastName: string;
  email: string;
  password?: string;
  countryCode?: string;
  phone?: string;
  role: UserRole;
}

interface AuthStore {
  user: User | null;
  isAuthenticated: boolean;
  setUser: (user: User) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      user: null,
      isAuthenticated: false,
      setUser: (user) => set({ user, isAuthenticated: true }),
      logout: () => set({ user: null, isAuthenticated: false }),
    }),
    {
      name: "auth-storage",
    }
  )
);
